<template>
  <div id="synopsis">
    <div v-if="edit" v-html="maInfo.periodicalIntro">
      {{ maInfo.periodicalIntro }}
    </div>
    <div v-else>
      <Editor :id="'editor'" v-model="formValidate.content" :placeholder="'请输入期刊简介'" @changeValue="getIntroduction"/>
    </div>
    <div class="btn">
      <div v-if="edit" @click="setEdit" :class="edit ? 'affirm' : 'close'">
        编辑
      </div>
      <div v-if="!edit" @click="back" class="close">取消</div>
      <div v-if="!edit" @click="sub" class="affirm">保存</div>
    </div>
  </div>
</template>

<script>
import Editor from "../../../components/editor";
export default {
  name: "synopsis",
  components: {
    Editor
  },
  props: ["maInfo"],
  mounted() {
    this.formValidate.content = this.maInfo.periodicalIntro
  },
  data() {
    return {
      edit: true,
      formValidate: {
        content: "",
      },
    };
  },
  methods: {
    setEdit() {
      this.edit = false;
    },
    back() {
      this.edit = true;
    },
    async sub() {
      let obj = {
        periodicalDatabase: this.periodicalDatabase,
        periodical: {
          periodicalIntro: this.formValidate.content,
        },
      };
      let res = await this.$apis.userServe.setMaInfo(obj);
      this.$Message.success("成功");
      console.log(res);
      let data = await this.$apis.loginServe.getUserInfo();
      let userObj = {
        token: sessionStorage.getItem("token"),
        hasLogin: true,
        userInfo: data.content,
      };
      this.$store.commit("loginInfo", userObj);
      this.$emit("getDetails");
      this.edit = true;
    },
    getIntroduction(vla) {
      this.formValidate.content = vla;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  position: absolute;
  bottom: 20px;
  width: 1060px;
  display: flex;
  justify-content: center;
  align-items: center;

  height: 50px;
  //background: pink;
  .close {
    text-align: center;
    line-height: 38px;
    width: 72px;
    height: 38px;
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 8px;
    margin-right: 13px;
    cursor: pointer;
  }

  .affirm {
    margin-left: 13px;
    text-align: center;
    line-height: 38px;
    width: 70px;
    height: 36px;
    color: #fff;
    background: #007fff;
    border-radius: 8px;
    cursor: pointer;
  }
}
#synopsis {
  position: relative;
  margin-top: 15px;
  width: 1200px;
  padding: 50px 70px 70px;
  min-height: 790px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
}

#text-container ::v-deep .placeholder {
  color: #999;
}

#text-container ::v-deep .w-e-text-container {
  z-index: 1 !important;
}

#toolbar-container ::v-deep .w-e-toolbar {
  justify-content: center;
  z-index: 2 !important;
}

#toolbar-container {
  margin-top: 17px;
}

#text-container {
  width: 100%;
  height: 600px;
  border: none;
  outline: none;
  padding: 4px 7px;
  color: #515a6e;
}
</style>
